// Centralised content for the best-horse-apps SEO landing — EN + NL.
// Mirrors structure so both pages render the same template.

const FAQ_EN = [
  {
    q: "What is the best horse app overall?",
    a: "For most riders, Equilab remains the best overall horse app thanks to its automatic gait recognition, deep training analysis and the largest active equestrian community. EquiSight is the strongest all-in-one alternative — it adds breeding, stable management and AI coaching on top of training tracking.",
  },
  {
    q: "Which horse app is better than Equilab?",
    a: "Equilab is excellent for riding-only use, but riders who also need breeding records, vet management, stable invoicing or AI coaching often switch to EquiSight, HorseAnalytics or Equestic SaddleClip.",
  },
  {
    q: "What is the best horse management app?",
    a: "BarnManager, Stable Secretary and EquineM lead the horse management category. BarnManager is built for elite show barns; Stable Secretary excels at clean records; EquineM is the most international.",
  },
  {
    q: "Are there free horse apps available?",
    a: "Yes. Equilab, HorseDay, FarmKeep, Horse Rider SOS and Happie Horse App all offer free tiers. Horse Rider SOS is 100% free with no upsell.",
  },
  {
    q: "Which horse app has the best AI coaching features?",
    a: "EquiSight leads in AI breadth (AI coach, AI competition analysis, AI nutrition, AI breeding and AI management). HorseAnalytics and Equestic SaddleClip are strong runners-up.",
  },
];

const FAQ_NL = [
  {
    q: "Wat is de beste paardenapp in het algemeen?",
    a: "Voor de meeste ruiters is Equilab de beste paardenapp dankzij automatische gangherkenning, diepe trainingsanalyse en de grootste actieve ruitercommunity. EquiSight is het sterkste alles-in-één alternatief — met fokkerij, stalmanagement en AI-coaching erbovenop.",
  },
  {
    q: "Welke paardenapp is beter dan Equilab?",
    a: "Equilab is uitstekend voor alleen rijden, maar ruiters die ook fokkerij-registratie, dierenarts-beheer, stal-facturatie of AI-coaching nodig hebben stappen vaak over naar EquiSight, HorseAnalytics of Equestic SaddleClip.",
  },
  {
    q: "Wat is de beste paardenbeheer-app?",
    a: "BarnManager, Stable Secretary en EquineM leiden de paardenbeheer-categorie. BarnManager is voor topwedstrijdstallen; Stable Secretary excelleert in schone registratie; EquineM is het meest internationaal.",
  },
  {
    q: "Zijn er gratis paardenapps beschikbaar?",
    a: "Ja. Equilab, HorseDay, FarmKeep, Horse Rider SOS en Happie Horse App hebben allemaal een gratis tier. Horse Rider SOS is 100% gratis zonder upsell.",
  },
  {
    q: "Welke paardenapp heeft de beste AI-coaching?",
    a: "EquiSight loopt voorop in AI-breedte (AI coach, AI wedstrijdanalyse, AI voeding, AI fokkerij en AI management). HorseAnalytics en Equestic SaddleClip volgen.",
  },
];

const PERSONAS_EN = [
  {
    id: "recreational",
    name: "Recreational Riders",
    blurb: "If you hack out 1–3 times a week, look for a free tier, automatic gait recognition and fall detection.",
    picks: ["equilab", "horseday", "horse-rider-sos"],
  },
  {
    id: "dressage",
    name: "Dressage Riders",
    blurb: "Dressage benefits from sensor data — symmetry, impulsion, rhythm. Combine a tracking app with a coach video platform.",
    picks: ["equestic-saddleclip", "equilab", "ridely"],
  },
  {
    id: "jumpers",
    name: "Show Jumpers",
    blurb: "Jumpers need competition planning, jumping analytics, FEI integration and video for course walks.",
    picks: ["horseanalytics", "ridely", "barnmanager"],
  },
  {
    id: "owners",
    name: "Horse Owners",
    blurb: "Owners need a single source of truth — vet, farrier, vaccinations, expenses.",
    picks: ["stable-secretary", "happie-horse", "horse-records"],
  },
  {
    id: "breeders",
    name: "Breeders",
    blurb: "Pedigrees, mare planning and AI breeding advice are non-negotiable.",
    picks: ["breeders-app", "equinegenie", "equitrace"],
  },
  {
    id: "trainers",
    name: "Trainers",
    blurb: "Trainers need multi-user permissions, training schedules, billing and coach-to-rider feedback.",
    picks: ["equinem", "barnmanager", "equisight"],
  },
  {
    id: "stable-owners",
    name: "Stable Owners",
    blurb: "Pension barns live or die on billing and contracts. Pick boarding-first software.",
    picks: ["stables-co", "stable-secretary", "barnmanager"],
  },
];

const PERSONAS_NL = [
  {
    id: "recreational",
    name: "Recreatieve Ruiters",
    blurb: "Als je 1–3 keer per week buitenrijdt, kies voor een gratis tier, automatische gangherkenning en valdetectie.",
    picks: ["equilab", "horseday", "horse-rider-sos"],
  },
  {
    id: "dressage",
    name: "Dressuurruiters",
    blurb: "Dressuur profiteert van sensor-data — symmetrie, impuls, ritme. Combineer een tracking-app met een coach-videoplatform.",
    picks: ["equestic-saddleclip", "equilab", "ridely"],
  },
  {
    id: "jumpers",
    name: "Springruiters",
    blurb: "Springruiters hebben wedstrijdplanning, sprong-analyse, FEI-koppeling en video voor parcoursverkenning nodig.",
    picks: ["horseanalytics", "ridely", "barnmanager"],
  },
  {
    id: "owners",
    name: "Paardeneigenaren",
    blurb: "Eigenaren willen één centrale plek voor dierenarts, hoefsmid, vaccinaties en kosten.",
    picks: ["stable-secretary", "happie-horse", "horse-records"],
  },
  {
    id: "breeders",
    name: "Fokkers",
    blurb: "Stambomen, merrieplanning en AI-fokadvies zijn essentieel.",
    picks: ["breeders-app", "equinegenie", "equitrace"],
  },
  {
    id: "trainers",
    name: "Trainers",
    blurb: "Trainers hebben rechten per gebruiker, trainingsschema's, facturatie en coach-naar-ruiter feedback nodig.",
    picks: ["equinem", "barnmanager", "equisight"],
  },
  {
    id: "stable-owners",
    name: "Stalhouders",
    blurb: "Pensionstallen draaien op facturatie en contracten. Kies pension-eerst software.",
    picks: ["stables-co", "stable-secretary", "barnmanager"],
  },
];

const CATEGORY_GROUPS_EN = [
  {
    key: "training",
    title: "Best Riding Tracker Apps",
    subtitle: "GPS, gait recognition and ride analytics",
    intro: "Riding tracker apps automatically log every ride and analyse your gaits, speed, distance and route.",
    picks: ["equilab", "ridely", "equestic-saddleclip"],
  },
  {
    key: "stable",
    title: "Best Horse Management Apps",
    subtitle: "Single-source-of-truth for owners and small barns",
    intro: "Management apps centralise vet, farrier, training and competition records per horse.",
    picks: ["barnmanager", "equinem", "horseanalytics"],
  },
  {
    key: "professional",
    title: "Best Stable Management Software",
    subtitle: "Boarding, invoicing and staff scheduling",
    intro: "Stable management software is for professional barns: boarding contracts, automated invoicing, staff scheduling.",
    picks: ["stable-secretary", "stables-co", "barnmanager"],
  },
  {
    key: "health",
    title: "Best Horse Health Apps",
    subtitle: "Medication, vaccinations, vet and farrier",
    intro: "Health apps focus on vaccinations, medication, deworming, weight, temperature and farrier visits.",
    picks: ["equitrace", "stable-secretary", "farmkeep"],
  },
  {
    key: "ai",
    title: "Best AI Horse Apps",
    subtitle: "AI coaching, AI insights and predictive analytics",
    intro: "AI horse apps are the fastest-growing category in 2026.",
    picks: ["equisight", "horseanalytics", "equestic-saddleclip"],
  },
];

const CATEGORY_GROUPS_NL = [
  {
    key: "training",
    title: "Beste Rij-Tracker Apps",
    subtitle: "GPS, gangherkenning en rit-analyse",
    intro: "Rij-tracker apps loggen automatisch elke rit en analyseren gangen, snelheid, afstand en route.",
    picks: ["equilab", "ridely", "equestic-saddleclip"],
  },
  {
    key: "stable",
    title: "Beste Paardenbeheer Apps",
    subtitle: "Eén centrale registratie voor eigenaren en kleine stallen",
    intro: "Paardenbeheer-apps centraliseren dierenarts, hoefsmid, training en wedstrijdregistratie per paard.",
    picks: ["barnmanager", "equinem", "horseanalytics"],
  },
  {
    key: "professional",
    title: "Beste Stalmanagement Software",
    subtitle: "Pension, facturatie en personeelsplanning",
    intro: "Stalmanagement-software is voor professionele stallen: pensioncontracten, automatische facturatie en personeelsplanning.",
    picks: ["stable-secretary", "stables-co", "barnmanager"],
  },
  {
    key: "health",
    title: "Beste Gezondheidsapps",
    subtitle: "Medicatie, vaccinaties, dierenarts en hoefsmid",
    intro: "Gezondheidsapps richten zich op vaccinaties, medicatie, ontworming, gewicht, temperatuur en hoefsmid-bezoeken.",
    picks: ["equitrace", "stable-secretary", "farmkeep"],
  },
  {
    key: "ai",
    title: "Beste AI Paardenapps",
    subtitle: "AI-coaching, AI-inzichten en voorspellende analyses",
    intro: "AI-paardenapps zijn de snelst groeiende categorie in 2026.",
    picks: ["equisight", "horseanalytics", "equestic-saddleclip"],
  },
];

const EQUILAB_ALT_EN = [
  { slug: "equestic-saddleclip", reason: "Sensor-based symmetry and impulsion data. Better for dressage analysis." },
  { slug: "horseanalytics", reason: "Adds a professional network of vets and instructors plus richer training analytics." },
  { slug: "horseday", reason: "Lighter, free, more social. Best if Equilab feels too heavy." },
  { slug: "equisight", reason: "All-in-one — absorbs Equilab's tracking and adds breeding, stable management and AI." },
];

const EQUILAB_ALT_NL = [
  { slug: "equestic-saddleclip", reason: "Sensor-gestuurde symmetrie- en impuls-data. Beter voor dressuuranalyse." },
  { slug: "horseanalytics", reason: "Voegt een netwerk van dierenartsen en instructeurs toe + diepere analyse." },
  { slug: "horseday", reason: "Lichter, gratis, socialer. Voor wie Equilab te zwaar vindt." },
  { slug: "equisight", reason: "Alles-in-één — neemt Equilab's tracking over en voegt fokkerij, stalmanagement en AI toe." },
];

const FEATURES_EXPLAINED_EN = [
  { key: "gps", title: "GPS Tracking", body: "GPS tracking records distance, speed, route and elevation during every ride. Modern apps automatically segment your ride into walk, trot, canter and gallop." },
  { key: "safety", title: "Safety Tracking", body: "Safety features include automatic fall detection, live location sharing, an SOS button and safe-rider check-ins. Horse Rider SOS is free and has saved multiple lives." },
  { key: "health", title: "Health Records", body: "Capture vaccinations, deworming, Coggins, temperature, weight and injury notes per horse. Look for export and team sharing." },
  { key: "farrier", title: "Farrier Management", body: "Track shoe cycles, lameness notes, hoof photos and the next appointment. Best when the farrier adds records from their own phone." },
  { key: "vet", title: "Vet Management", body: "Beyond medication lists — prescriptions, dosing schedules with reminders, vet visit history and a digital file you can hand a new clinic." },
  { key: "feeding", title: "Feeding Logs", body: "Track ration per horse, supplements, hay quality and water intake. SmartPak builds a personalised plan based on age, workload and condition." },
  { key: "competition", title: "Competition Tracking", body: "Event calendars, start lists and scores — premium tiers usually include FEI and KNHS integration." },
  { key: "ai-coach", title: "AI Coaching", body: "AI coaching is the newest feature. The best implementations give immediate feedback on rider position or suggest interval-training adjustments." },
];

const FEATURES_EXPLAINED_NL = [
  { key: "gps", title: "GPS Tracking", body: "GPS-tracking registreert afstand, snelheid, route en hoogteverschil. Moderne apps segmenteren automatisch tussen stap, draf, galop en ren." },
  { key: "safety", title: "Veiligheid", body: "Veiligheidsfuncties zoals automatische valdetectie, live locatie en SOS-knop. Horse Rider SOS is gratis en heeft levens gered." },
  { key: "health", title: "Gezondheids­registratie", body: "Leg vaccinaties, ontworming, temperatuur, gewicht en blessures per paard vast. Let op export en teamdeling." },
  { key: "farrier", title: "Hoefsmid", body: "Volg hoefcycli, kreupelheidsnotities, hoeffoto's en de volgende afspraak. Het werkt het best wanneer de hoefsmid zelf registreert." },
  { key: "vet", title: "Dierenarts", body: "Verder dan medicatielijsten — recepten, doseringen met herinneringen, dierenartsbezoek-geschiedenis en een digitaal dossier." },
  { key: "feeding", title: "Voeding", body: "Rantsoen per paard, supplementen, hooi-kwaliteit en waterinname. SmartPak bouwt een persoonlijk plan op basis van leeftijd en belasting." },
  { key: "competition", title: "Wedstrijden", body: "Wedstrijdkalenders, startlijsten en uitslagen — premium tiers koppelen met FEI en KNHS." },
  { key: "ai-coach", title: "AI Coaching", body: "AI-coaching is de nieuwste functie. De beste implementaties geven directe feedback op ruiterhouding." },
];

const METHODOLOGY_EN = [
  { title: "Coverage", body: "We track 25+ active horse apps worldwide and add new entrants quarterly." },
  { title: "Feature taxonomy", body: "Every app is mapped against the same 50+ feature taxonomy across 9 categories." },
  { title: "Composite score", body: "A weighted composite of functional breadth, public rating, review volume and AI capability." },
  { title: "Independence", body: "Sponsored apps are clearly marked. Editorial scores are never influenced by sponsorship." },
  { title: "Updates", body: "Prices refreshed monthly, feature matrices quarterly, ranking on every major app release." },
];

const METHODOLOGY_NL = [
  { title: "Dekking", body: "We volgen 25+ actieve paardenapps wereldwijd en voegen elk kwartaal nieuwe toe." },
  { title: "Functietaxonomie", body: "Elke app is geclassificeerd tegen dezelfde 50+ functies in 9 categorieën." },
  { title: "Samengestelde score", body: "Een gewogen samenstelling van functiebreedte, beoordeling, aantal reviews en AI-capaciteit." },
  { title: "Sponsorbeleid", body: "Gesponsorde apps zijn duidelijk gemarkeerd. Editorial scores worden nooit beïnvloed." },
  { title: "Updates", body: "Prijzen maandelijks, functie-matrices per kwartaal, ranking bij elke grote app-release." },
];

const FINAL_RECS_EN = [
  { title: "Top 5 overall", picks: ["equisight", "equilab", "stable-secretary", "horseanalytics", "barnmanager"] },
  { title: "Top 5 for beginners", picks: ["equilab", "horseday", "happie-horse", "horse-rider-sos", "horse-records"] },
  { title: "Top 5 for professionals", picks: ["barnmanager", "equinem", "equisight", "ridely", "equestic-saddleclip"] },
  { title: "Top 5 for stable owners", picks: ["stables-co", "stable-secretary", "barnmanager", "equinem", "equinegenie"] },
];

const FINAL_RECS_NL = [
  { title: "Top 5 algemeen", picks: ["equisight", "equilab", "stable-secretary", "horseanalytics", "barnmanager"] },
  { title: "Top 5 voor beginners", picks: ["equilab", "horseday", "happie-horse", "horse-rider-sos", "horse-records"] },
  { title: "Top 5 voor professionals", picks: ["barnmanager", "equinem", "equisight", "ridely", "equestic-saddleclip"] },
  { title: "Top 5 voor stalhouders", picks: ["stables-co", "stable-secretary", "barnmanager", "equinem", "equinegenie"] },
];

export const BEST_HORSE_APPS_CONTENT = {
  en: {
    lang: "en",
    urlPath: "/best-horse-apps",
    title: "Best Horse Apps in 2026: Compare 100+ Equestrian Apps",
    description: "Compare the world's best horse apps. Find the perfect equestrian app for riding, horse management, health, safety and stable management.",
    eyebrow: "The Global Equine Software Intelligence Platform",
    h1: "Best Horse Apps in 2026: Compare the World's Leading Equestrian Apps",
    heroLede: "An in-depth review of the best horse apps for owners, riders, breeders, trainers and stable managers — based on 50+ tracked functionalities across 9 categories and 25+ active apps worldwide.",
    updatedLabel: "Updated",
    updatedDate: "February 12, 2026",
    authorLabel: "By",
    author: "HorseAppCompare Editorial Team",
    independentLabel: "",
    breadcrumbHome: "Home",
    breadcrumbHere: "Best Horse Apps",
    quickCompareTitle: "Quick Comparison of the Best Horse Apps",
    quickCompareLede: "The ten highest-scoring horse apps on our platform, ranked by composite score. Tap any row for the full breakdown.",
    cols: { app: "App", rating: "Rating", price: "Price", ai: "AI", gps: "GPS", health: "Health", stable: "Stable", multi: "Multi-user", platforms: "Platforms" },
    whatIsTitle: "What Is a Horse App?",
    whatIsBody: [
      "A horse app — sometimes called an equestrian app or horse owner app — is a mobile or web application that helps anyone working with horses to track, plan and improve daily life around the barn.",
      "In 2026 we group horse apps into five practical buckets:",
    ],
    whatIsBuckets: [
      ["Riding apps", "Equilab, HorseDay, Equestic SaddleClip. Log rides, recognise gaits, produce analytics."],
      ["Management apps", "BarnManager, EquineM, HorseAnalytics. Centralise vet, farrier, vaccinations, expenses."],
      ["Health apps", "EquiTrace, FarmKeep, Happie Horse. Medical compliance and continuity of care."],
      ["Stable software", "Stable Secretary, Stables.co, BarnManager. Boarding, invoicing, staff scheduling."],
      ["AI coaching apps", "EquiSight, HorseAnalytics, Ridely. Personalised training feedback and predictions."],
    ],
    whatIsClose: "Most riders end up using two apps — one for tracking, one for management — until they find an all-in-one platform that does both well.",
    byCategoryTitle: "Best Horse Apps by Category",
    byCategoryLede: "Different riders have radically different needs. Below are the strongest apps in each category with the top three picks.",
    seeAll: "See all",
    personasTitle: "Which Horse App Is Best For You?",
    personasLede: "The right horse app depends on what you actually do with horses. Pick the persona closest to your situation.",
    equilabAltTitle: "Equilab Alternatives",
    equilabAltLede: "Equilab is the most-downloaded riding app in the world, but it isn't right for everyone. The four apps below are the strongest alternatives in 2026.",
    equilabAltNote: "Worth knowing: Equilab is still the right pick if all you want is reliable, automatic ride tracking with a great community.",
    featuresTitle: "Horse App Features Explained",
    featuresLede: "Eight functionalities to look for — what they actually do and why they matter.",
    methodologyEyebrow: "Editorial methodology",
    methodologyTitle: "How We Compare Horse Apps",
    methodologyLede: "We track every claim against the public release of each app. Here is exactly how the rankings are produced.",
    finalRecsEyebrow: "Editor's picks",
    finalRecsTitle: "Final Recommendations",
    finalRecsLede: "The shortlist. Four lists for the four situations we get asked about every week.",
    faqTitle: "Frequently Asked Questions",
    faqLede: "The five questions we get most often about comparing horse apps.",
    ctaTitle: "Still not sure which horse app to pick?",
    ctaLede: "Talk to our advisor. Describe your situation in one sentence and get a personalised shortlist in seconds.",
    ctaPrimary: "Ask the advisor",
    ctaSecondary: "Compare side by side",
    faq: FAQ_EN,
    personas: PERSONAS_EN,
    categoryGroups: CATEGORY_GROUPS_EN,
    equilabAlts: EQUILAB_ALT_EN,
    featuresExplained: FEATURES_EXPLAINED_EN,
    methodology: METHODOLOGY_EN,
    finalRecs: FINAL_RECS_EN,
    free: "Free",
    monthly: "/mo",
    reviews: "reviews",
  },
  nl: {
    lang: "nl",
    urlPath: "/beste-paardenapps",
    title: "Beste Paardenapps in 2026: Vergelijk 100+ Ruiter-apps",
    description: "Vergelijk de beste paardenapps ter wereld. Vind dé equestrian app voor rijden, paardenbeheer, gezondheid, veiligheid en stalmanagement.",
    eyebrow: "Het wereldwijde paardensoftware intelligence platform",
    h1: "Beste Paardenapps in 2026: Vergelijk de Toonaangevende Ruiter-apps",
    heroLede: "Een diepgaande review van de beste paardenapps voor eigenaren, ruiters, fokkers, trainers en stalmanagers — gebaseerd op 50+ functies in 9 categorieën en 25+ actieve apps wereldwijd.",
    updatedLabel: "Bijgewerkt",
    updatedDate: "12 februari 2026",
    authorLabel: "Door",
    author: "HorseAppCompare Redactie",
    independentLabel: "",
    breadcrumbHome: "Home",
    breadcrumbHere: "Beste Paardenapps",
    quickCompareTitle: "Snelle Vergelijking van de Beste Paardenapps",
    quickCompareLede: "De tien hoogst-scorende paardenapps op ons platform, gerangschikt op samengestelde score. Tik op een rij voor het volledige overzicht.",
    cols: { app: "App", rating: "Score", price: "Prijs", ai: "AI", gps: "GPS", health: "Gezondheid", stable: "Stal", multi: "Multi-user", platforms: "Platforms" },
    whatIsTitle: "Wat Is Een Paardenapp?",
    whatIsBody: [
      "Een paardenapp — ook wel equestrian app of paardeneigenaar-app — is een mobiele of web-applicatie die iedereen die met paarden werkt helpt om het dagelijks leven rond de stal te volgen, plannen en verbeteren.",
      "In 2026 groeperen we paardenapps in vijf praktische categorieën:",
    ],
    whatIsBuckets: [
      ["Rij-apps", "Equilab, HorseDay, Equestic SaddleClip. Ritten loggen, gangen herkennen, analyse maken."],
      ["Beheer-apps", "BarnManager, EquineM, HorseAnalytics. Dierenarts, hoefsmid, vaccinaties, kosten centraliseren."],
      ["Gezondheidsapps", "EquiTrace, FarmKeep, Happie Horse. Medische naleving en continuïteit van zorg."],
      ["Stalsoftware", "Stable Secretary, Stables.co, BarnManager. Pension, facturatie, personeelsplanning."],
      ["AI-coaching apps", "EquiSight, HorseAnalytics, Ridely. Persoonlijke trainingsfeedback en voorspellingen."],
    ],
    whatIsClose: "De meeste ruiters gebruiken twee apps — één voor tracking, één voor beheer — totdat ze een alles-in-één platform vinden dat beide goed doet.",
    byCategoryTitle: "Beste Paardenapps per Categorie",
    byCategoryLede: "Elke ruiter heeft andere behoeften. Hieronder de sterkste apps per categorie met de top drie picks.",
    seeAll: "Bekijk alle",
    personasTitle: "Welke Paardenapp Past Bij Jou?",
    personasLede: "De juiste paardenapp hangt af van wat je met paarden doet. Kies het profiel dat het dichtst bij jouw situatie ligt.",
    equilabAltTitle: "Equilab Alternatieven",
    equilabAltLede: "Equilab is de meest gedownloade rij-app ter wereld, maar niet voor iedereen de juiste keuze. De vier apps hieronder zijn de sterkste alternatieven in 2026.",
    equilabAltNote: "Goed om te weten: Equilab blijft de juiste keuze als je alleen betrouwbare automatische rit-tracking en een goede community wilt.",
    featuresTitle: "Paardenapp-Functies Uitgelegd",
    featuresLede: "Acht functies om op te letten — wat ze doen en waarom ze belangrijk zijn.",
    methodologyEyebrow: "Editorial methodiek",
    methodologyTitle: "Hoe Wij Paardenapps Vergelijken",
    methodologyLede: "We toetsen elke claim aan de publieke release van elke app. Zo komen de rankings tot stand.",
    finalRecsEyebrow: "Aanbevelingen van de redactie",
    finalRecsTitle: "Definitieve Aanbevelingen",
    finalRecsLede: "De shortlist. Vier lijsten voor de vier vragen die we elke week krijgen.",
    faqTitle: "Veelgestelde Vragen",
    faqLede: "De vijf vragen die we het meest krijgen over paardenapp-vergelijkingen.",
    ctaTitle: "Nog niet zeker welke paardenapp je moet kiezen?",
    ctaLede: "Praat met onze adviseur. Beschrijf je situatie in één zin en krijg een persoonlijke shortlist in seconden.",
    ctaPrimary: "Vraag de adviseur",
    ctaSecondary: "Vergelijk naast elkaar",
    faq: FAQ_NL,
    personas: PERSONAS_NL,
    categoryGroups: CATEGORY_GROUPS_NL,
    equilabAlts: EQUILAB_ALT_NL,
    featuresExplained: FEATURES_EXPLAINED_NL,
    methodology: METHODOLOGY_NL,
    finalRecs: FINAL_RECS_NL,
    free: "Gratis",
    monthly: "/mnd",
    reviews: "reviews",
  },
};
